import { temporarilyNotSupport } from '../../utils'

// 用户信息
export const getUserProfile = /* @__PURE__ */ temporarilyNotSupport('getUserProfile')
export const getUserInfo = /* @__PURE__ */ temporarilyNotSupport('getUserInfo')
